module.exports = __webpack_public_path__ + "img/Chemistry.f01e35ec.svg";